import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class GatewayIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() } d="M0,10l0-5h16l0,5H0z M8,7H2v1h6V7z M15,6h-5v3h5V6z M14,8h-3V7h3V8z M0,4l0-3h16l0,3H0z M15,2h-5v1h5V2z M16,16
	H0l0-5h16L16,16z M8,13H2v1h6V13z M15,12h-5v3h5V12z M14,14h-3v-1h3V14z"
          fillRule='evenodd' clipRule='evenodd'/>
  ]
  getViewBox = () => '0 0 16 16'
}


